<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="false">
            <el-form-item class="form-title" prop="i_id" label="港口ID" style="width: 350px">
                <div class="mrA">{{formData.i_id}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" label="港口名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_ename" label="英文名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_ename" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_ename}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_national" label="归属国家" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_national" filterable @change="gjChange" size="mini" style="margin-right: 9px;width:110px; " >
                    <el-option v-for="item in gjList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_national}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_province" label="归属省份" style="width: 350px" >
                <el-select v-if="canEdit" v-model="formData.i_province" filterable clearable @change="sfChange" size="mini" style="margin-right: 9px;width:110px; " >
                    <el-option v-for="item in sfList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_province}}</div>
            </el-form-item>

            <el-form-item prop="isuse" label="是否启用" style="width: 350px" v-if="data.i_id!=0">
                <el-radio-group v-model="formData.isuse" v-if="canEdit">
                    <el-radio  :label="1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.isuse==1?'是':'否'}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 350px" >
                <div class="mrA" >{{formData.vc_lruname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 350px" >
                <div class="mrA" >{{formData.dt_createtime}}</div>
            </el-form-item>
        </el-form>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "GsPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    isuse:1,
                },
                canEdit:false,
                disabled:false,
                gjList:[],
                sfList:[],
                rules:{
                    vc_name:[{required: true,message:'港口名称不能为空'}],

                    vc_ename:[{required: true,message:'英文名不能为空'}],
                    i_national:[{required: true,message:'归属国家不能为空'}],
                    // isuse:[{required: true,message:'是否启用不能为空'}],
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getAreaTree();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.i_id==0){
                this.canEdit=true;
                this.formData.i_id=0;
                this.formData.isuse=1;
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                this.getAreaTree(0)

            }else{
                this.formData=JSON.parse(JSON.stringify(this.data))
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            // console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },

            cancel(){
                this.$emit('close')
            },
            gjChange(){
                this.formData.vc_national=this.gjList.find(gj=>gj.i_id==this.formData.i_national).vc_name
                this.getAreaTree(this.formData.i_national);
                this.sfList=[];
                this.formData.i_province='';
                this.formData.vc_province=''

            },
            sfChange(val){
                if(val){
                    this.formData.i_province=val;
                    this.formData.vc_province=this.sfList.find(gj=>gj.i_id==this.formData.i_province).vc_name
                }
                this.$forceUpdate()
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        if(this.data.i_id==0){
                            this.addSeaPort()

                        }else{
                            this.editSeaPort()
                        }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                this.getAreaTree(0)
                this.getAreaTree(this.formData.i_national)


            },
            async getAreaTree(i_id=0){
                let param = {
                    i_pid:i_id,
                    isuse:1,
                };
                let res = await API.getAreaTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        if (i_id==0){
                            this.gjList=   res.data
                        }else{
                            this.sfList=   res.data
                        }
                    }
                    // return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //新增
            async addSeaPort(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.addSeaPort(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
            //编辑
            async editSeaPort(){
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.editSeaPort(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.canEdit=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }

</style>